import { useRouter } from "expo-router";

import { HeaderAndFooterLayout } from "@/blocks/HeaderAndFooterLayout";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnText } from "@/components/VnText/VnText";

export default function LandingScreen() {
  const router = useRouter();

  const handleGoToAuth = () => {
    router.navigate({ pathname: "/(unauthed)/auth" });
  };

  return (
    <HeaderAndFooterLayout>
      <VnBox className="mt-safe-offset-10 flex h-full items-center justify-center">
        <VnBox className="w-full gap-4 md:w-2/5">
          <VnButton onPress={handleGoToAuth}>
            <VnText i18nKey="native:landingScreen.goToAuth" />
          </VnButton>
        </VnBox>
      </VnBox>
    </HeaderAndFooterLayout>
  );
}
